import React, { useState } from "react";
import PropTypes from "prop-types";

import { Background } from "components";
import { K_COLORS_WHITE } from "constants.js";

const ContactLink = (props) => {
  const { children, onClick, isSelected } = props;
  const [IsHovered, setIsHovered] = useState(false);

  const backgroundSize = isSelected ? 36 : 32;

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      style={styles.icon}
    >
      <Background
        style={styles.iconBackground}
        size={backgroundSize}
        isActive={IsHovered || isSelected}
      >
        {children}
      </Background>
    </div>
  );
};

const styles = {
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: "38px",
    height: "38px",
    position: "relative",
    marginTop: "0.2rem",
    marginBottom: "0.2rem",
  },
  iconBackground: {
    backgroundColor: K_COLORS_WHITE,
    borderRadius: "50%",
  },
};

ContactLink.propTypes = {
  children: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default ContactLink;
